import React from 'react';
import {getEnvName} from './util'
import gm from './media/gm.png';
import './Environment.css';

function Environment() {
  var EnvironmentStr = getEnvName() + " Environment";
  return (
    <div>
      <div className="gm">
           <img src={gm} alt="GM" className="GM"/>
      </div>
      <div className="navigationContainerTop">3d Visualization Telemetry</div>
      <div className="navigationContainerBottom">{EnvironmentStr}</div>
    </div>
  );
}


export default Environment;
